module.exports = __webpack_public_path__ + "img/icon-1-1.69d109c1.png";